import React from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import { SitzungProvider } from './sitzung.jsx'
import './index.css'
import { faerbeStatusleiste } from './thema.js'
import { zoomSperren } from './zoomsperre.js'

faerbeStatusleiste()
zoomSperren()

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <SitzungProvider>
        <App />
      </SitzungProvider>
    </BrowserRouter>
  </React.StrictMode>
)

// Service Worker nur im gebauten Stand: im Dev-Betrieb wuerde er die
// Hot-Reload-Dateien von Vite abfangen.
if (import.meta.env.PROD && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((fehler) => {
      console.warn('Service Worker nicht registriert:', fehler)
    })
  })
}
